import { createSelector } from '@reduxjs/toolkit';
import { RootState, store } from '@store/store';



export const selectUser = (state: RootState) => state.auth.user;
export const selectAppAuthMode = (state: RootState) => state.auth.appAuthMode;



export const selectUserId = createSelector(selectUser, user => user ? user.userId : "");
export const selectUserRoles = createSelector(selectUser, user => user && user.roles ? user.roles : []);



export const plainSelectUser = () => {
	const storeObject = store.getState();
	return storeObject && storeObject.auth ? storeObject.auth.user : null;
};